// extracted by mini-css-extract-plugin
export default {"resetButton":"DwT25th","badge":"TOjkHK8","intentDefault":"wJPa3vO"};